import Navbar from '@/components/Navbar';

export default {
  name: 'Colors',
  components: {
    Navbar
  },
  data () {
    return {
      redirect_domain: "",
      color_name: "",
      color_image: "",
      editColorDialogue:false,
      overlay: false,
      search: "",
      editColorImage:"",

      validationFlag: [
        v => !!v || 'This is required',
      ],
      
      configurations: {
        "client_name": "",
        "client_description": "",
        "x_account_id": "",
        "isEnable": false,
        "Test":true,
        "secretKeyStaging":"",
        "secretKeyProduction":""
      },
     
      limit_filter: 50,
      all_colors_list:[],
      searchDebounce: null,
      loading_data: true,
      page: 1,
      colorToEditId:" ",
      pageCount: 0,
      itemsPerPage: 50,
      perPageOptions: [5, 10, 50, 100, 150, 200, 250],
      add_color_dialog: false,
      snackbar: false,
      snackbar_text: '',
      snackbar_timeout: 2000,

      columns: [
        { text: 'Color Name', value: 'color_name' },
        { text: 'Color Image', value: 'colorimage' },
      ],
      
      headers: [
        { text: 'Color Name', value: 'color_name' },
        { text: 'Color Image', value: 'colorimage' },
        { text: '', value: 'Delete' },
        { text: '', value: 'Edit' },
        { text: '', value: 'Download' }
       
      ],
    }
  },

  created() {
    this.initialize()
  },
  
  mounted() {},
  
  watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3000)
    },
  },
  
  methods: {
    
    initialize() {
     this.getConfigurations()
    },
    
    getConfigurations() {
      this.snackbar_text = "Getting Configurations"
      this.snackbar = true
      this.loading_data = true
      this.$Axios.get(this.$backendURL + "/configure_payment_app?shop=" + this.$shop, {  
        headers: {
          'Authorization': this.$API_TOKEN.replace('%20', ' '),    
        }
      }).then((response) => {
        this.configurations.x_account_id = response.data.x_account_id
        this.configurations.secretKeyProduction = response.data.secretKeyProduction
        this.configurations.client_description = response.data.client_description
        this.configurations.client_name = response.data.client_name
        this.configurations.isEnable = response.data.isEnable
        this.configurations.Test = response.data.Test
      }, (error) => {
        this.snackbar_text = "We are Facing Technical Issues please try again Later"
        this.snackbar = true
        if (error.response.data.detail == "Session expired, Reopen the application!") {
          this.$router.push('/error')
        }
      });
    },

    sendConfigurations() {
      this.redirect_domain = ""
      this.snackbar_text = "Sending Configurations ..."
      this.overlay = true
      this.snackbar = true
      this.$Axios.post(this.$backendURL + "/configure_payment_app?shop=" + this.$shop,this.configurations, {  
        headers: {
          'Authorization': this.$API_TOKEN.replace('%20', ' '),
        }
      }).then((response) => {
        this.snackbar_text = "Configurations Saved"
        this.snackbar = true
        this.redirect_domain = response.data.redirect_domain;
        if (this.redirect_domain != "") {
          window.open(this.redirect_domain)
        }
      }, (error) => {
        this.snackbar_text = "We are Facing Technical Issues please try again Later"
        this.snackbar = true
        if (error.response.data.detail == "Session expired, Reopen the application!") {
          this.$router.push('/error')
        }
      });
    },
  }
}